
import $ from 'jquery';

var thelang = document.getElementsByTagName('html')[0].getAttribute('lang');

class Calendar{
    constructor(){
        this.containercalendar = $("#customcalendar");
        this.containercalendarvalue = "customcalendar";
        this.language = document.getElementsByTagName('html')[0].getAttribute('lang');
        var viewtype=$("#customcalendar").data("viewtype");
        if (viewtype) {
            this.viewtype = "&viewtype="+viewtype;
        } else {       
            this.viewtype = "";
        }
        this.events();        
    }
  
    // Events
    events() {       
        this.getResults(this);
    }
    
    // Methods
    getResults() {  
        if (this.language == "el") {      
            var jsonurl='https://summer-schools.uoc.gr/wp-json/summerschools/v1/calendar/?type=all&language=el' + this.viewtype;
            $.getJSON(jsonurl, this.callbackFuncWithData.bind(this));       
        } else {
            var jsonurl='https://summer-schools.uoc.gr/wp-json/summerschools/v1/calendar/?type=all&language=en' + this.viewtype;
            $.getJSON(jsonurl, this.callbackFuncWithData.bind(this));    
        } 
    }

    callbackFuncWithData(json){        
        var calendarEl = document.getElementById( this.containercalendarvalue );            
        var calendar = new FullCalendar.Calendar(calendarEl, json);        
        calendar.render(); 
    }
   
}

export default Calendar;